import { render } from "./grid-item.vue?vue&type=template&id=b5af09c0"
import script from "./grid-item.vue?vue&type=script&lang=js"
export * from "./grid-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__